.ugc-review-item-top-review-wrap {
  .top-review-content {
    min-height: 25vh;
    max-height: 60vh;
    overflow-y: auto;
  }
  .top-review-opration {
    border-top: 1px solid var(--gray-300);
  }
}
